// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__2B7lD","description":"MealItem_description__2s9zg","price":"MealItem_price__1dHMC"};